import { Alert, AlertProps } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { colors } from 'constants/theme'

/**
 * Inline informational note styled with the system's themeSecondColor
 * (teal) instead of MUI's default blue. Used across dashboard-targets
 * tabs (and anywhere else we want a quiet hint that matches the
 * primary brand palette).
 *
 * Accepts the same props as MUI Alert so callers can override icon,
 * action, sx, etc. when they need to.
 */
export default function InfoBanner(props: AlertProps) {
  const { children, sx, icon, ...rest } = props
  return (
    <Alert
      severity="info"
      icon={icon ?? <InfoOutlinedIcon sx={{ color: colors.themeSecondColor }} />}
      {...rest}
      sx={{
        backgroundColor: colors.themeSecondColor10,
        color: colors.textPrimary,
        border: `1px solid ${colors.themeSecondColor30}`,
        borderRadius: '8px',
        '& .MuiAlert-icon': { color: colors.themeSecondColor },
        ...sx,
      }}
    >
      {children}
    </Alert>
  )
}
